import { render, staticRenderFns } from "./ReplyContent.vue?vue&type=template&id=5cf0dc7c&scoped=true&"
import script from "./ReplyContent.vue?vue&type=script&lang=js&"
export * from "./ReplyContent.vue?vue&type=script&lang=js&"
import style0 from "./ReplyContent.vue?vue&type=style&index=0&id=5cf0dc7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0dc7c",
  null
  
)

export default component.exports